import { useState } from 'react';
import { Paper, Avatar, Typography, Grid, Button } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { getFirstCharacter } from '../../shared/components/CustomAvatar';
import { makeStyles } from '@material-ui/core/styles';
import { blue, green, orange, red } from '@material-ui/core/colors';
import ErrorLogDetails from './ErrorLogDetails'

const useStyles = makeStyles((theme) => ({
    primary: {
        color: theme.palette.getContrastText(blue[500]),
        backgroundColor: blue[500],
    },
    info: {
        color: theme.palette.getContrastText(blue[200]),
        backgroundColor: blue[200],
    },
    success: {
        color: theme.palette.getContrastText(green[400]),
        backgroundColor: green[400],
    },
    warning: {
        color: theme.palette.getContrastText(orange[200]),
        backgroundColor: orange[200],
    },
    error: {
        color: theme.palette.getContrastText(red[300]),
        backgroundColor: red[300],
    },

}));


const PRIMARY_NAME = ['A', 'N', 'H', 'L', 'Q', '9', '8'];
const INFO_NAME = ['F', 'G', 'T', 'I', 'J', '1', '2', '3'];
const SUCCESS_NAME = ['K', 'D', 'Y', 'B', 'O', '4', '5'];
const WARNING_NAME = ['P', 'E', 'R', 'S', 'C', 'U', '6', '7'];
const ERROR_NAME = ['V', 'W', 'X', 'M', 'Z'];


export default function ErrorLogCard({ error_log, action }) {
    const { ErrorMessage: name } = error_log;
    const logo = name;
    const classes = useStyles();
    const [modal2State, setModal2State] = useState(false);

    const handle2Cancel = () => {
        setModal2State(false);
    }

    const handle2Open = () => {
        setModal2State(true);
    }


    const getAvatarColor = (name) => {
        if (PRIMARY_NAME.includes(getFirstCharacter(name))) return classes.primary;
        if (INFO_NAME.includes(getFirstCharacter(name))) return classes.info;
        if (SUCCESS_NAME.includes(getFirstCharacter(name))) return classes.success;
        if (WARNING_NAME.includes(getFirstCharacter(name))) return classes.warning;
        if (ERROR_NAME.includes(getFirstCharacter(name))) return classes.error;
        return 'default';
    }

    return (
        <>

            <Paper elevation={4} style={{ width: '100%', marginTop: 10, }}>
                <Grid container justify="space-between" spacing={2}>
                    <Grid container item xs={9} spacing={2} alignItems="center">

                        <Grid item style={{ marginLeft: 15 }}>
                            <Avatar variant="rounded" src={logo} alt={name} className={getAvatarColor(name)}>
                                {getFirstCharacter(name)}
                            </Avatar>
                        </Grid>

                        <Grid item style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            width: '55%'
                        }}>
                            <Typography variant="overline">
                                {name}
                            </Typography>
                        </Grid>
                    </Grid>
                    {modal2State &&
                        <ErrorLogDetails visible={modal2State} handle2Cancel={handle2Cancel} error_log={error_log} />}
                    <Grid container item xs={3} alignContent='center'>
                        <Grid item  >
                            <Button size="small"
                                variant="outlined"
                                color="primary"
                                onClick={handle2Open}
                            >
                                Ouvrir
                            </Button>

                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
}

export const ErrorLogCardSkeleton = () => {


    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rect" width="100%" height="40" />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rect" width="100%" height="40" />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rect" width="100%" height="40" />
            </Grid>
        </Grid>
    );
}